module.exports = __webpack_public_path__ + "img/gszz0@2x.6b389869.png";